import script from "./OnboardingAiResearchTableBody.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingAiResearchTableBody.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingAiResearchTableBody.vue?vue&type=style&index=0&id=d0caaea2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0caaea2"]])

export default __exports__